// ---- HMR 時のスクロール維持（ページ遷移は除外）----
const SCROLL_KEY = '__dev_scroll__';
const CUR_URL = location.pathname + location.search + location.hash;

// HMR: 差し替え前に保存 → 差し替え後に復元
if (module && module.hot) {
  const prev = module.hot.data && module.hot.data.__scroll__;
  if (prev && prev.url === CUR_URL) {
    window.scrollTo(prev.x || 0, prev.y || 0);
  }
  module.hot.dispose((data) => {
    data.__scroll__ = { x: window.scrollX, y: window.scrollY, url: CUR_URL };
  });
}

// フルリロード対策：保存（URL付き & タイムスタンプ）
window.addEventListener('beforeunload', () => {
  try {
    sessionStorage.setItem(
      SCROLL_KEY,
      JSON.stringify({ x: window.scrollX, y: window.scrollY, url: CUR_URL, t: Date.now() })
    );
  } catch {}
});

// 復元：URL一致 & 保存が直近（例：2秒以内）の時だけ実行
window.addEventListener('DOMContentLoaded', () => {
  try {
    const s = sessionStorage.getItem(SCROLL_KEY);
    if (!s) return;
    const saved = JSON.parse(s);
    if (saved.url === CUR_URL && Date.now() - saved.t < 2000) {
      window.scrollTo(saved.x || 0, saved.y || 0);
    }
  } catch {}
});

var $ = require("jquery");

import "../scss/style.scss";
import "./script.js";
import "./animate.js";
